module.exports = __webpack_public_path__ + "img/44.239e65ff.jpg";